'use client';
/** @jsxImportSource @emotion/react */

import { type ElementType, forwardRef, type Ref } from 'react';

import type {
  OverridableComponent,
  OverrideProps,
} from '@mui/material/OverridableComponent';

import MuiBackdrop, {
  type BackdropTypeMap as MuiBackdropTypeMap,
} from '@mui/material/Backdrop';

type ExcludedMuiProps = 'transitionDuration';

type CustomProps = {
  component?: ElementType;
};

type BackdropTypeMap<
  P = CustomProps,
  D extends ElementType = MuiBackdropTypeMap['defaultComponent'],
> = {
  defaultComponent: D;
  props: Omit<MuiBackdropTypeMap['props'], ExcludedMuiProps> & P;
};

export type BackdropProps<
  D extends ElementType = MuiBackdropTypeMap['defaultComponent'],
  P = CustomProps,
> = OverrideProps<MuiBackdropTypeMap<P, D>, D>;

const BackdropComponent = (props: BackdropProps, ref: Ref<HTMLDivElement>) => {
  return <MuiBackdrop {...props} ref={ref} />;
};

BackdropComponent.displayName = 'Backdrop';

export const Backdrop = forwardRef(
  BackdropComponent
) as OverridableComponent<BackdropTypeMap>;
